/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ListenContractDto {
  assetCode?: string;
  network?: ListenContractDto.NetworkEnum;
  contract?: string;
  minAmount?: number;
  address?: string;
}
export namespace ListenContractDto {
  export const NetworkEnum = {
    Trc20: 'TRC20',
    Erc20: 'ERC20',
    Bank: 'BANK',
    Tassat: 'TASSAT',
    MaticErc20: 'MATIC_ERC20',
  } as const;
  export type NetworkEnum = (typeof NetworkEnum)[keyof typeof NetworkEnum];
}
